import { render, staticRenderFns } from "./FudaoStudentInviteDialog.vue?vue&type=template&id=ca89590e&scoped=true&"
import script from "./FudaoStudentInviteDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoStudentInviteDialog.vue?vue&type=script&lang=js&"
import style0 from "./FudaoStudentInviteDialog.vue?vue&type=style&index=0&id=ca89590e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca89590e",
  null
  
)

export default component.exports